$(function () {
    var $side = $('.assist-side');
    $side.find('.right-fixed-bar-item').click(function () {
      if($side.hasClass('assist-side-hide')){
          $side.removeClass('assist-side-hide');
      }
    });
    
    /*$(document).scroll(function () {
        var windowH = window.innerHeight || document.documentElement.clientHeight;
        if($(window).scrollTop() > windowH){
            $side.addClass('assist-side-hide');
        }else{
            $side.removeClass('assist-side-hide');
        }
    });*/
});